import React from "react";
import AccordionSection from "./AccordionSection";

const workItems = [
  {
    title: "Agent Orchestrator",
    role: "Core Contributor",
    description:
      "Multi-agent orchestration platform for coordinating autonomous AI coding agents. Manages parallel workstreams across Claude Code, Codex, and OpenClaw with real-time status tracking, PR lifecycle management, and intelligent task routing.",
    links: [
      { label: "Code", url: "https://github.com/ashish921998/agent-orchestrator" },
    ],
  },
  {
    title: "Vinesight",
    role: "Founder & Builder",
    description:
      "AI-powered social media monitoring and insights platform. Uses LLMs to analyze trends, detect emerging narratives, and surface actionable intelligence from public conversations at scale.",
    links: [
      { label: "Code", url: "https://github.com/ashish921998/Vinesight" },
    ],
  },
  {
    title: "Aimeter",
    role: "Creator",
    description:
      "Developer tool for measuring and benchmarking AI agent performance. Tracks metrics like task completion rate, token efficiency, and code quality across different AI coding assistants and workflows.",
  },
  {
    title: "Scope PM",
    role: "Creator",
    description:
      "AI-native project management tool designed for agent-assisted development workflows. Features automated task decomposition, agent assignment, and progress tracking for teams shipping with AI.",
    links: [
      { label: "Code", url: "https://github.com/ashish921998/Scope" },
    ],
  },

];

function Work() {
  return <AccordionSection title="Work" items={workItems} delay="0.2s" />;
}

export default Work;
